import React from 'react';
import PropTypes from 'prop-types';
import { FeatureConsumer } from './context';
import getFeatures from './getFeatures';

/**
 * Decorator supporting adding features to a component automatically under a features prop.
 */
function Features({ featuresRequired, children }) {
    // get everything rather than just one item, hence "true"

    return (
        <FeatureConsumer>
            {({ featuresData, categories }) => {
                const features = getFeatures(featuresData, categories, featuresRequired);
                return React.cloneElement(children, { features });
            }}
        </FeatureConsumer>
    );
}

Features.propTypes = {
    featuresRequired: PropTypes.array,
    children: PropTypes.func,
};

export default Features;
